export default {"src":"/_next/static/media/instalmentPeriod.95a1d9fc.svg","height":117,"width":1234};